import winter from '../../imgs/snow.jpg'
import { FiArrowUpRight, FiBookOpen, FiFileText, FiHome, FiPhone, FiRefreshCw } from 'react-icons/fi'

const TabDocuments = () => {
    const documents = [
        { title: "IPA Homeowner's Manual", detail: 'Community information and guidance for property owners.', href: '/PDFs/owner_handbook.pdf', icon: FiBookOpen },
        { title: 'IPA Bylaws', detail: 'The governing rules of the Indian Park Association.', href: '/PDFs/bylaws.pdf', icon: FiFileText },
        { title: 'Community House Rental', detail: 'Rental terms and agreement for the community house.', href: '/PDFs/community_house_rental_agreement.pdf', icon: FiHome },
        { title: '2024 Newsletter', detail: 'A look back at community news and updates from 2024.', href: '/PDFs/newsletter_2024.pdf', icon: FiFileText },
        { title: 'Recycling Information', detail: 'Local recycling guidance and collection information.', href: '/PDFs/recycling.pdf', icon: FiRefreshCw },
        { title: 'Local Government Contacts', detail: 'Town departments, services, and official contact details.', href: 'https://www.townofwarwick.org/contacts/', icon: FiPhone },
    ]

    return (
        <div className='tab-wrapper'>
            <section className='page-hero compact-hero'>
                <img className='hero-image' src={winter} alt="Snow-covered trees overlooking Greenwood Lake" />
                <div className='hero-shade'></div>
                <div className='hero-content'>
                    <span className='eyebrow'>Resident resources</span>
                    <h1>Community documents</h1>
                    <p>Quick access to the handbooks, agreements, and local information residents use most.</p>
                </div>
            </section>

            <section className='page-section'>
                <div className='section-heading'>
                    <span className='eyebrow dark'>Document library</span>
                    <h2>Everything important, easy to find.</h2>
                    <p>Select any resource to open it in a new tab.</p>
                </div>
                <div className='resource-grid'>
                    {documents.map(({ title, detail, href, icon: Icon }) => (
                        <a className='resource-card' href={href} target="_blank" rel="noopener noreferrer" key={title}>
                            <span className='resource-icon'><Icon /></span>
                            <span className='resource-copy'>
                                <strong>{title}</strong>
                                <span>{detail}</span>
                            </span>
                            <FiArrowUpRight className='resource-arrow' aria-hidden="true" />
                        </a>
                    ))}
                </div>
            </section>
        </div>
    )
}
export default TabDocuments
